import Splide from '@splidejs/splide';

export const QAndA = (() => {
	'use strict';

	let sliders,
	settings;

	function init() {
		sliders = document.getElementsByClassName('splide');

		if ( sliders.length === 0 ) {
			return;
		}

		settings = {
			direction: 'ttb',
			height: '400px',
			pagination: true,
			arrows: false,
			breakpoints: {
				768 : {
					direction: 'ltr'
				},
			}
		};		

		for ( var i = 0; i < sliders.length; i++ ) {
			new Splide( sliders[ i ], settings ).mount();
		}

		resizeSliders();
		window.addEventListener('resize', resizeSliders);
	}

	function resizeSliders(){
		for ( var i = 0; i < sliders.length; i++ ) {
			let slideContents = sliders[i].querySelectorAll('.slide__content');
			let tallest = 0;

			for (var ii = 0; ii < slideContents.length; ii++) {
				var height = slideContents[ii].offsetHeight;

				if (height > tallest) {
					tallest = height;
				}
			}

			sliders[ i ].style.setProperty('--height', (tallest+80)+'px');
		}
	}

	return {
		init: init,
	};
})();
